import axiosInstance from './axiosInstance';

export interface BulkEditRequestBody {
  assetIds: string[];
  dryRun?: boolean;
  operations: Array<{ field: string; op: 'set' | 'clear' | 'append' | 'remove' | 'replace'; value?: any; values?: any[]; applyCategoryTemplateDefaults?: boolean }>;
  guards?: { onlyIfEmpty?: string[]; onlyIfEquals?: { field: string; value: any }[] };
}

export async function bulkEditDryRun(body: BulkEditRequestBody) {
  const { data } = await axiosInstance.post(`/api/assets/bulk-update`, { ...body, dryRun: true });
  return data;
}

export async function bulkEditExecute(body: BulkEditRequestBody) {
  const { data } = await axiosInstance.post(`/api/assets/bulk-update`, { ...body, dryRun: false });
  return data;
}


